module.exports = __webpack_public_path__ + "static/media/download.bb64e4f0.svg";